import { inject } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { catchError, exhaustMap, filter, map, of, withLatestFrom } from 'rxjs';
import { MapReportGroupActions } from '../../../../shared/components/map-report-group/store/map-report-group.actions';
import { MapReportGroupService } from '@portal/shared/components/map-report-group/map-report-group.service';
import { Store } from '@ngrx/store';
import { selectSelectedArea } from '@portal/shared/components/map-report-group/store/map-report-group.reducer';
import { devicesListingSource } from '../constants/devices.constants';
import { ListingPageActions } from '@portal/shared/components/listing-page/store/listing-page.actions';

export const filtersRefetched = createEffect(
  (actions$ = inject(Actions)) => {
    return actions$.pipe(
      ofType(MapReportGroupActions.createReportGroupSuccess),
      filter(({ source, pageId }) => source === devicesListingSource && !!pageId),
      exhaustMap(({ pageId }) =>
        of(
          ListingPageActions.fetchFilterModels({
            pageId: pageId!,
            location: null
          })
        )
      )
    );
  },
  { functional: true, dispatch: true }
);

export const devicesSelected = createEffect(
  (actions$ = inject(Actions), mapReportGroupApiService = inject(MapReportGroupService), store = inject(Store)) =>
    actions$.pipe(
      ofType(MapReportGroupActions.fetchDevicesForSelectedArea),
      filter(({ source }) => source === devicesListingSource),
      withLatestFrom(store.select(selectSelectedArea)),
      exhaustMap(([{ filters, search }, selectedArea]) => {
        return mapReportGroupApiService
          .getMapAreaDevices({
            coordinates: selectedArea.map(item => ({
              longitude: item[0],
              latitude: item[1]
            })),
            filters: [filters],
            search
          })
          .pipe(
            map(devicesResponse =>
              MapReportGroupActions.fetchDevicesForSelectedAreaSuccess({ deviceIds: devicesResponse.devices })
            ),
            catchError(() => of(MapReportGroupActions.fetchDevicesForSelectedAreaSuccess({ deviceIds: [] })))
          );
      })
    ),
  { functional: true, dispatch: true }
);
